(function () {
  function initTypewriter(el) {
    if (el.dataset.typewriterInit === 'true') return;

    var raw = el.getAttribute('data-phrases') || '';
    var phrases = raw
      .split('|')
      .map(function (phrase) {
        return phrase.trim();
      })
      .filter(Boolean);

    if (!phrases.length) return;

    el.dataset.typewriterInit = 'true';

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      el.textContent = phrases[0];
      return;
    }

    var typeSpeed = 55;
    var deleteSpeed = 28;
    var holdDelay = 1500;
    var nextDelay = 400;

    var phraseIndex = 0;
    var charIndex = 0;
    var deleting = false;

    function tick() {
      var current = phrases[phraseIndex];

      if (!deleting) {
        charIndex += 1;
        el.textContent = current.slice(0, charIndex);

        if (charIndex === current.length) {
          deleting = true;
          setTimeout(tick, holdDelay);
          return;
        }

        setTimeout(tick, typeSpeed);
        return;
      }

      charIndex -= 1;
      el.textContent = current.slice(0, charIndex);

      if (charIndex === 0) {
        deleting = false;
        phraseIndex = (phraseIndex + 1) % phrases.length;
        setTimeout(tick, nextDelay);
        return;
      }

      setTimeout(tick, deleteSpeed);
    }

    tick();
  }

  function init() {
    document.querySelectorAll('[data-ff-search-typewriter]').forEach(initTypewriter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
